/*@flow*/
import React from 'react';
import Blank from 'lib/Blank';
import { getCartoSQLTask } from 'lib/getCartoSQL';
import { getAnalysis, type CartoResponse } from 'lib/getCartoMap';
import hash from 'lib/hash';

type Props = {
  mapConfig: ?CartoResponse,
  analysisId: ?(string | string[]),
  children: ({ data: Object }) => React$Node,
  queryTransform?: string => string,
};
type State = { data: Object[] };

export default class ChartContainer extends React.Component<Props, State> {
  state = {
    data: [],
  };

  execution: any;

  fetchData() {
    const sql = this.getQuery(this.props);
    if (!sql) return;

    this.execution = getCartoSQLTask(sql)
      .map(res => {
        this.setState({ data: res.rows });
        return res;
      })
      .orElse(err => {
        console.error(err);
      })
      .run();
  }

  getQuery({ mapConfig, analysisId }: Props) {
    if (!mapConfig) return null;
    if (!analysisId) return null;
    if (typeof analysisId !== 'string') return null;
    const analysis = getAnalysis(mapConfig, analysisId);
    if (!analysis) return null;
    const { queryTransform } = this.props;
    let sql = analysis.query;
    if (queryTransform) {
      sql = queryTransform(sql);
    }
    return sql;
  }

  componentWillUnmount() {
    this.execution && this.execution.cancel();
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate() {
    this.fetchData();
  }

  shouldComponentUpdate(np: Props, ns: State) {
    return (
      hash(np.mapConfig) !== hash(this.props.mapConfig) ||
      hash(this.state.data) !== hash(ns.data)
    );
  }

  render() {
    const props = this.props;
    const { data } = this.state;
    if (Blank.is(data)) return null;

    return props.children({ data });
  }
}
